import React from 'react';
import { useState, useEffect } from 'react';
import './experience.css';
import {BsPatchCheckFill} from 'react-icons/bs';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

const Experience = () => {

  const [experiences, setExperience] = useState([]);

  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch('https://rush-general-backend.onrender.com/experiences')
        .then(response => response.json())
        .then(data =>  {
          const sortedExperience = data.sort((a, b) => b.order - a.order);
          setExperience(sortedExperience)
        });

// empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  return (
	<section id="experience">
    <h5>What work experience I have</h5>
    <h2>Experience</h2>
    <VerticalTimeline>
    {
      experiences.map((experience) => 
   
          <VerticalTimelineElement
            className="vertical-timeline-element--work work"
            contentStyle={{ background: '#2c2c6c', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  #4db5ff' }}
            date={experience.date}
            iconStyle={{ background: '#2c2c6c', color: '#4db5ff' }}
            icon={<BsPatchCheckFill />}
          >
            <h3 className="vertical-timeline-element-title">{experience.position}</h3>
            <h4 className="vertical-timeline-element-subitle">{experience.company}, {experience.location}</h4>
            <p>
              {experience.Description1}
            </p>
            <p>
              {experience.Description2}
            </p>
          </VerticalTimelineElement>
      )
    }
    </VerticalTimeline>
    

    
  </section>
  )
}

export default Experience;
